import { random } from '../helpers'

if (typeof crypto !== 'undefined' && !crypto.randomUUID) {
    crypto.randomUUID = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = (random() * 16) | 0
            return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
        }) as `${string}-${string}-${string}-${string}-${string}`
    }
}
